module.exports = "/assets/7b60ad9e72ebcb66b40a4d192fb324ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/HA.png
// module id = 762
// module chunks = 0